<template>
  <div class="BrandListing layout-container mb-32 desk:mb-56">
    <div
      v-if="brandCategories.length"
      class="border-b border-light  py-24 desk:py-32"
    >
      <div class="type-headline-xl">
        {{ brandCategoryFilter === '' ? $t('brandlist.allCategories') : brandCategoryFilter }}
      </div>
      <div class="mt-12 flex flex-wrap gap-8">
        <button
          class="btn btn--tab"
          :class="{
            selected: brandCategoryFilter === ''
          }"
          @click="brandCategoryFilter = ''"
        >
          {{ $t('brandlist.allCategories') }}
        </button>
        <button
          v-for="cat in brandCategories"
          :key="cat"
          class="btn btn--tab"
          :class="{
            selected: brandCategoryFilter === cat
          }"
          @click="brandCategoryFilter = cat"
        >
          {{ cat }}
        </button>
      </div>
    </div>
    <div
      v-for="(value, key, index) in brands"
      :key="index"
      class="flex w-full items-start border-b border-light py-24 desk:py-32"
    >
      <div
        class="type-headline-2xl desk:type-headline-4xl basis-1/4 desk:basis-3/12"
      >
        {{ key }}
      </div>
      <div

        class="basis-3/4 desk:basis-9/12"
      >
        <div
          v-for="(thisBrand, index2) in value"
          :key="index2"
          class="flex type-sm items-center mb-18 last:m-0"
        >
          <AddRemoveFavoriteBrand
            v-if="!userStore.isCustomerSuccessUser"
            :brand-id="thisBrand.brandCode"
            design="minimal"
            class="mr-8"
          />
          <nuxt-link
            :to="$manualUrl(thisBrand.brandLink)"
            class="block border-light"
          >
            {{ thisBrand.brandName }}
          </nuxt-link>
          <div
            class="inline-block px-8 py-4 bg-purplePrimary text-lightest type-tagline-xxs ml-8 empty:hidden"
          >
            {{ thisBrand.brandFlag }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BrandItem, useGlobalContentStore } from '~/store/globalContent';
import AddRemoveFavoriteBrand from '~/components/product/AddRemoveFavoriteBrand.vue';
import { useUserStore } from '~/store/user';
const globalContent = useGlobalContentStore();
const userStore = useUserStore();


type BrandList = {
  [key: string]: BrandItem[]
}

await useAsyncData('load-brands',
  async() => {
    return await globalContent.loadBrands();
  }
);

const brandCategoryFilter = ref('');

const brandCategories = computed(()=> {
  return globalContent.brandList
    .filter((f)=> f.showInAutomaticList && f.brandCategory !== '')
    .map((m) => m.brandCategory.toLowerCase())
    .sort((a, b) => a.localeCompare(b, 'sv'))
    .filter((v,i,a) => a.indexOf(v) === i); // remove duplicates
});

const usedBrands = computed(()=> {
  const output = globalContent.brandList.filter((f)=> f.showInAutomaticList);
  if (brandCategoryFilter.value === '') {
    return output;
  }
  return output.filter((f) => f.brandCategory.toLowerCase() === brandCategoryFilter.value);
});

const brands = computed<BrandList>(() => {
  const letterSplit = {} as BrandList;
  const regex = /[0-9]/g;
  usedBrands.value.forEach((i) => {
    let firstLetter = i.brandName.charAt(0);
    if (firstLetter.match(regex)) {
      firstLetter = '0 - 9';
    }
    if (!letterSplit[firstLetter]) {
      letterSplit[firstLetter] = [];
    }
    letterSplit[firstLetter].push(i);
  });

  return letterSplit;
});
</script>

<style scoped lang="postcss">
</style>
